import { apiDaInscricao } from "../../../servicos/axios";

export interface BuscarLocaisParams {
  descricao?: string;
  idCidade?: string | number;
  paginaAtual?: number;
}

export type LocalDeAtendimento = {
  id: number;
  descricao: string;
  cidadeComUf: string;
};

export type BuscarLocaisResponse = {
  modelo: LocalDeAtendimento[];
  totalDeRegistros: number;
  paginaAtual: number;
  totalDePaginas: number;
};

export const buscarLocaisAtendimento = async (
  params?: BuscarLocaisParams
): Promise<BuscarLocaisResponse> => {
  const query = new URLSearchParams();
  query.append("descricao", params?.descricao ?? "");
  query.append("idCidade", params?.idCidade?.toString() ?? "");
  query.append("paginaAtual", String(params?.paginaAtual ?? 1));

  const response = await apiDaInscricao().get(
    `/LocalDeAtendimento?${query.toString()}`
  );

  return response.data as BuscarLocaisResponse;
};
